import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=c0a3e74a&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=c0a3e74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a3e74a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0a3e74a')) {
      api.createRecord('c0a3e74a', component.options)
    } else {
      api.reload('c0a3e74a', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=c0a3e74a&scoped=true&", function () {
      api.rerender('c0a3e74a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/welfareCenter/Login.vue"
export default component.exports